import {
  PARAMETERS_SET_COUPON,
} from './action-types';

export const setCoupon = (coupon) => async (dispatch) => {
  const payload = {
    coupon,
  };

  dispatch({
    type: PARAMETERS_SET_COUPON,
    payload,
  });

  return payload;
};
